import history from '../../util/history'

const toEditView = roomId => {
  history.push(`/hotels/${roomId}/edit`)

  return true
}

export default toEditView
